import PropTypes from 'prop-types';

import { Section, FooterSimplified } from '@spotahome/ui-library';

import Header from './Header';
import InstitutionInfo from './InstitutionInfo';
import StudentOpinion from './StudentOpinion';
import InfoBox from './InfoBox';
import Facilities from './Facilities';

const Institution = props => {
  const { data } = props;
  return (
    <div>
      <Header
        title={data.headerInformationAbout}
        subtitle={data.headerSubtitle}
        image={data.headerImage}
      />

      <Section background="light">
        <div className="grid__wrapper--inner institution-info-wrapper">
          <InstitutionInfo
            title={data.guideTitle}
            description={data.guideContent}
            faculties={data.guideNumberFaculties}
            students={data.guideNumberOfStudents}
            languages={data.guideLanguagesTaught}
            courses={data.guideCourses}
            prices={data.guidePrices}
            web={data.guideWeb}
            email={data.guideEmail}
            direction={data.guideDirection}
            phone={data.guidePhone}
          />
        </div>

        <div className="grid__wrapper--inner student-opinion-wrapper">
          <div className="student-opinion-row">
            {data.whatStudentsLikeTheMost && (
              <StudentOpinion
                title="What students like the most"
                content={data.whatStudentsLikeTheMost}
                className="student-opinion__title-like"
              />
            )}

            {data.whatStudentsDontLike && (
              <StudentOpinion
                title="What students don´t like"
                content={data.whatStudentsDontLike}
                className="student-opinion__title-no-like"
              />
            )}
          </div>
        </div>
      </Section>

      {(data.whatWeLikeTheMost || data.thingsToKeepInMind) && (
        <Section background="dark">
          <div className="grid__wrapper--inner infobox-wrapper">
            <div className="infobox-row">
              {data.whatWeLikeTheMost && (
                <InfoBox
                  title="What we like the most"
                  content={data.whatWeLikeTheMost}
                  className="infobox__title-like"
                />
              )}

              {data.thingsToKeepInMind && (
                <InfoBox
                  title="Things to keep in mind"
                  content={data.thingsToKeepInMind}
                  className="infobox__title-mind"
                />
              )}
            </div>
          </div>
        </Section>
      )}

      {data.facilitiesAndActivities && (
        <Section background="light">
          <div className="grid__wrapper--inner facilities-wrapper">
            <Facilities
              title="Facilities & Activities"
              content={data.facilitiesAndActivities}
            />
          </div>
        </Section>
      )}

      <FooterSimplified />
    </div>
  );
};

Institution.propTypes = {
  data: PropTypes.object.isRequired
};

export default Institution;
